import { DASH_ALERTS, DASH_ACTIVE_FORMS, DASH_COMPLETED_FORMS, DASH_GRADUATION_DEADLINE_MAP, DASH_GRADUATION_DEADLINE_TERM, DASH_OVERVIEW, DASH_TASKS } from "../actions-index";

export function dashboard(state = {}, action = {}) {
  const { type, payload = {} } = action;
  let alerts = {};
  let overview = {};
  let forms = {};
  let graduationDeadlineMap = {};
  let tasks = {};

  switch (type) {
    case DASH_ALERTS:
      if (payload?.status) alerts.status = payload.status
      if (Array.isArray(payload?.alerts)) {
        alerts.status = "success"
        alerts.list = payload.alerts
      }
      return {
        ...state,
        alerts
      };
    case DASH_OVERVIEW:
      if(payload?.status) overview.status = payload.status;
      if(payload?.overview) overview.overview = payload.overview;
      return {
        ...state,
        overview
      };
    case DASH_ACTIVE_FORMS:
      if (payload?.status) forms.status = payload.status
      if (Array.isArray(payload?.forms)) {
        forms.status = "success"
        forms.list = payload.forms
      }
      return {
        ...state,
        active: forms
      };
      case DASH_COMPLETED_FORMS:
        if (payload?.status) forms.status = payload.status
        if (Array.isArray(payload?.forms)) {
          forms.status = "success"
          forms.list = payload.forms
        }
        return {
          ...state,
          completed: forms
        };
    case DASH_GRADUATION_DEADLINE_MAP:
      if(payload?.status) graduationDeadlineMap.status = payload.status;
      if(payload?.graduationDeadlineMap) graduationDeadlineMap.map = payload.graduationDeadlineMap;
      return {
        ...state,
        graduationDeadlineMap
      };
    case DASH_TASKS:
      if(payload?.status) tasks.status = payload.status;
      if(payload?.tasks) tasks.list = payload.tasks;
      return {
        ...state,
        tasks
      };
    default:
      return state;
  }
}

export function dashboardGraduationDeadlineTerm(state = null, action = {}) {
    return (action.type === DASH_GRADUATION_DEADLINE_TERM ? action.payload: null);
}